'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dAccount$002dUsers$002dPage$0024 from "./presto.-List-Account-Users-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002473 from "./presto.-Presto-Router$$anon$73.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dAccount$002dName$0024 from "./presto.types$-Account-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$72() {
  this.bmD = null;
  this.bmv = null;
  this.bmw = false;
  this.bmE = null;
  this.bmF = false;
  this.bmI = null;
  this.bmB = null;
  this.bmC = false;
  this.bmx = null;
  this.bmy = false;
  this.bmz = null;
  this.bmA = false;
  this.bmG = false;
  this.bmH = false;
  this.bmD = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bmI = "ListAccountUsersPage";
}
export { $c_Lpresto_PrestoRouter$$anon$72 as $c_Lpresto_PrestoRouter$$anon$72 };
$p = $c_Lpresto_PrestoRouter$$anon$72.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$72;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$72() {
}
export { $h_Lpresto_PrestoRouter$$anon$72 as $h_Lpresto_PrestoRouter$$anon$72 };
$h_Lpresto_PrestoRouter$$anon$72.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bmD;
});
$p.L = (function() {
  if ((!this.bmw)) {
    this.bmv = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bmw = true;
  }
  return this.bmv;
});
$p.O = (function() {
  if ((!this.bmF)) {
    this.bmE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bmF = true;
  }
  return this.bmE;
});
$p.E = (function() {
  return this.bmI;
});
$p.t = (function() {
  if ((!this.bmC)) {
    this.bmB = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bmC = true;
  }
  return this.bmB;
});
$p.M = (function() {
  if ((!this.bmy)) {
    this.bmx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dName$0024.$m_Lpresto_types$AccountName$().adp(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bmy = true;
  }
  return this.bmx;
});
$p.Q = (function() {
  if ((!this.bmA)) {
    this.bmz = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002473.$c_Lpresto_PrestoRouter$$anon$73();
    this.bmA = true;
  }
  return this.bmz;
});
$p.w = (function() {
  if ((!this.bmH)) {
    this.bmG = false;
    this.bmH = true;
  }
  return this.bmG;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee507) => ((p) => \u03b4scrutinee507.cG4(p)))($j_presto$002e$002dList$002dAccount$002dUsers$002dPage$0024.$m_Lpresto_ListAccountUsersPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$72 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$72, "presto.PrestoRouter$$anon$72", ({
  OF: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$72 as $d_Lpresto_PrestoRouter$$anon$72 };
//# sourceMappingURL=presto.-Presto-Router$$anon$72.js.map
